<template>
  <div class="biz-date-picker">
    <c-selector :store="unitList" class="biz-unit"
                v-if="showUnitSelect"
                v-model="unit"
                :width="80"
                labelField="label"
                keyField="value" @change="onChangeUnit"></c-selector>

    <div class="biz-picker" v-click-outside="onClickOutside">
      <div class="biz-handler" @click="expand = !expand">
        <i class="cicon-calendar _icon"></i>
        <span class="label">{{resultLabel}}</span>
        <i class="cicon-down icon_"></i>
      </div>
      <div class="biz-down-panel" v-show="expand">
        <div class="c-tabs">
          <div class="c-tab-bar c-tab-normal">
            <span :class="{'c-tab': true, 'c-checked': showRelative}" @click="showRelative = true">
              <span>最近</span>
            </span>
            <span :class="{'c-tab': true, 'c-checked': !showRelative}" @click="showRelative = false">
              <span>自定义</span>
            </span>
          </div>
          <div class="c-tab-panel biz-shortcut" v-show="showRelative">
            <template v-if="unit.value === 'hour'">
              <c-button size="normal" v-if="showToday" :type="customCount === 0 ? 'primary' : 'normal'" @click="onRelative(0)">今天</c-button>
              <c-button size="normal" :type="customCount === 1 ? 'primary' : 'normal'" @click="onRelative(1)">昨天</c-button>
              <c-button size="normal" :type="customCount === 2 ? 'primary' : 'normal'" @click="onRelative(2)">前天</c-button>
            </template>
            <template v-else-if="unit.value === 'day'">
              <c-button size="normal" v-if="showToday" :type="customCount === 0 ? 'primary' : 'normal'" @click="onRelative(0)">今天</c-button>
              <c-button v-if="isUltralimit" size="normal" :type="customCount === 1 ? 'primary' : 'normal'" @click="onRelative(1)">最近1天</c-button>
              <c-button size="normal" :type="customCount === 7 ? 'primary' : 'normal'" @click="onRelative(7)">最近7天</c-button>
              <c-button size="normal" :type="customCount === 14 ? 'primary' : 'normal'" @click="onRelative(14)">最近14天</c-button>
              <c-button size="normal" :type="customCount === 30 ? 'primary' : 'normal'" @click="onRelative(30)">最近30天</c-button>
              <span class="biz-custom">
                近<c-input :width="60" v-model="customCount"/>天
              </span>
              <c-button type="primary" class="biz-sure" size="normal" @click="onRelative(customCount, 'day')">确定</c-button>
            </template>
            <template v-else-if="unit.value === 'week'">
              <c-button size="normal" :type="customCount === 4 ? 'primary' : 'normal'" @click="onRelative(4)">最近4周</c-button>
              <c-button size="normal" :type="customCount === 8 ? 'primary' : 'normal'" @click="onRelative(8)">最近8周</c-button>
              <c-button size="normal" :type="customCount === 12 ? 'primary' : 'normal'" @click="onRelative(12)">最近12周</c-button>
              <span class="biz-custom">
                近<c-input :width="60" v-model="customCount"/>周
              </span>
              <c-button type="primary" class="biz-sure" size="normal" @click="onRelative(customCount, 'week')">确定</c-button>
            </template>
            <template v-if="unit.value === 'month'">
              <c-button size="normal" :type="customCount === 1 ? 'primary' : 'normal'" @click="onRelative(1)">最近1个月</c-button>
              <c-button size="normal" :type="customCount === 2 ? 'primary' : 'normal'" @click="onRelative(2)">最近2个月</c-button>
              <c-button size="normal" :type="customCount === 3 ? 'primary' : 'normal'" @click="onRelative(3)">最近3个月</c-button>
            </template>
          </div>
          <div class="c-tab-panel" v-show="!showRelative">
            <c-date-picker v-if="unit.value === 'hour'"
                           :showToday="false"
                           v-model="hourDate"
                           :min="minDate"
                           :max="maxDate"></c-date-picker>
            <c-date-range-picker v-else
                                 v-model="dateRange"
                                 :min="minDate"
                                 :max="maxDate"></c-date-range-picker>
            <div style="text-align: right; margin-top: 10px">
              <c-button type="primary" size="normal" @click="onAbsolute">确定</c-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import {util} from '../../utils'
export default {
  name: 'datePicker',
  props: {
    value: null,
    includeToday: { // 相对时间是否包含今天（最近x天、最近x月、最近x周）
      type: Boolean,
      default: false
    },
    monthLimit: {
      type: Number,
      default: 3
    },
    showUnitSelect: {
      type: Boolean,
      default: true
    },
    showToday: { // 按小时/按天是否显示今天
      type: Boolean,
      default: true
    },
    /**
     * @description 启用按小时
     */
    hourAble: {
      type: Boolean,
      default: true
    },
    /**
     * 数据量是否超限，如果客户的数据量过大需要在切换类型时使用最小单位
     * 如果超限相对的时间不包含今天 computed relativeDateIncludeToday
     */
    isUltralimit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const relativeDateIncludeToday = this.isUltralimit ? false : this.includeToday
    let maxDate = new Date(new Date().getTime() - (relativeDateIncludeToday ? 0 : 1) * this.$util.dayTime)
    let minDate = new Date(maxDate.getTime())
    minDate.setMonth(minDate.getMonth() - this.monthLimit)
    // minDate.setDate(1)
    let data = {
      maxDate,
      minDate,
      unit: {value: 'day'},
      dateType: 'relative',
      dateRange: {
        startDate: null,
        endDate: null
      },
      hourDate: maxDate,
      expand: false,
      customCount: 7,
      showRelative: true
    }
    if (this.isUltralimit) {
      data.customCount = 1
    }
    let absolute = this.getAbsoluteDate(data.unit.value, data.customCount, data.maxDate)
    data.dateRange.startDate = absolute.startDate
    data.dateRange.endDate = absolute.endDate
    if (this.value) {
      data.dateType = this.value.dateType
      data.unit.value = this.value.unit
      if (data.dateType === 'relative') {
        data.customCount = parseInt(this.value.params[0])
        // 当前相对时间为"今天"但今天不可用时：设置选项为昨天
        if (data.unit.value === 'hour' && !this.showToday && data.customCount === 0) {
          data.customCount = 1
        }
        if (data.unit.value === 'hour') {
          data.hourDate = new Date(new Date() - data.customCount * this.$util.dayTime)
        }
        let absolute = this.getAbsoluteDate(data.unit.value, data.customCount, data.maxDate)
        data.dateRange.startDate = absolute.startDate
        data.dateRange.endDate = absolute.endDate
      } else {
        if (this.$util.isDate(this.value.params[0])) {
          data.dateRange.startDate = this.value.params[0]
          data.dateRange.endDate = this.value.params[1]
          if (this.value.unit === 'hour') {
            data.hourDate = new Date(...this.value.params[0].split('-'))
          }
        } else if (this.$util.isString(this.value.params[0])) { // yyyy-mm-dd
          data.dateRange.startDate = new Date(this.value.params[0])
          data.dateRange.endDate = new Date(this.value.params[1])
          if (this.value.unit === 'hour') {
            data.hourDate = new Date(this.value.params[0])
          }
        }
        // 绝对日期包含今天，但今天不可用时：设置结束时间为昨天
        let beginDateStr = util.dateFormat(data.dateRange.startDate)
        let endDateStr = util.dateFormat(data.dateRange.endDate)
        let todayStr = util.dateFormat(new Date())
        let yesterdayStr = util.dateFormat(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
        if (Date.parse(beginDateStr) >= Date.parse(todayStr) && !relativeDateIncludeToday) {
          data.dateRange.startDate = new Date(...yesterdayStr.split('-'))
        }
        if (Date.parse(endDateStr) >= Date.parse(todayStr) && !relativeDateIncludeToday) {
          data.dateRange.endDate = new Date(...yesterdayStr.split('-'))
        }
        if (data.unit.value === 'hour' && Date.parse(beginDateStr) >= Date.parse(todayStr) && !relativeDateIncludeToday) {
          data.hourDate = new Date(...yesterdayStr.split('-'))
        }
      }
    }
    return data
  },
  computed: {
    relativeDateIncludeToday() {
      if (this.isUltralimit) {
        return false
      } else {
        return this.includeToday
      }
    },
    unitList () {
      let list = [
        {label: '按小时', value: 'hour'},
        {label: '按天', value: 'day'},
        {label: '按周', value: 'week'},
        {label: '按月', value: 'month'}
      ]
      if (!this.hourAble) list.splice(0, 1)
      return list
    },
    resultLabel () {
      let label = ''
      if (this.dateType === 'relative') {
        let unit = '天'
        switch (this.unit.value) {
          case 'hour':
            if (this.customCount === 0) {
              label = '今天'
            } else if (this.customCount === 1) {
              label = '昨天'
            } else {
              label = '前天'
            }
            return label
          case 'day':
            if (this.customCount === 0) {
              label = '今天'
            } else {
              label = `最近${this.customCount}${unit}`
            }
            return label
          case 'week':
            unit = '周'
            break
          case 'month':
            unit = '月'
            break
        }
        label = `最近${this.customCount}${unit}`
      } else {
        if (this.unit.value === 'hour') {
          label = this.$util.dateFormat(this.hourDate)
        } else {
          label = `${this.$util.dateFormat(this.dateRange.startDate)} ~ ${this.$util.dateFormat(this.dateRange.endDate)}`
        }
      }
      return label
    },
    output () {
      let res = {
        dateType: this.dateType,
        unit: this.unit.value,
        params: [],
        absoluteValue: []
      }
      if (this.dateType === 'relative') {
        if (this.unit.value === 'hour') {
          res.params.push(this.customCount)
          res.params.push(this.customCount)
          res.absoluteValue.push(this.$util.dateFormat(this.hourDate))
          res.absoluteValue.push(this.$util.dateFormat(this.hourDate))
        } else {
          res.params = [this.customCount, this.relativeDateIncludeToday ? 0 : 1]
          res.absoluteValue.push(this.$util.dateFormat(this.dateRange.startDate))
          res.absoluteValue.push(this.$util.dateFormat(this.dateRange.endDate))
        }
      } else {
        if (this.unit.value === 'hour') {
          res.params.push(this.$util.dateFormat(this.hourDate))
          res.absoluteValue.push(this.$util.dateFormat(this.hourDate))
          res.params.push(this.$util.dateFormat(this.hourDate))
          res.absoluteValue.push(this.$util.dateFormat(this.hourDate))
        } else {
          res.params.push(this.$util.dateFormat(this.dateRange.startDate))
          res.absoluteValue.push(this.$util.dateFormat(this.dateRange.startDate))
          res.params.push(this.$util.dateFormat(this.dateRange.endDate))
          res.absoluteValue.push(this.$util.dateFormat(this.dateRange.endDate))
        }
      }
      res.params = res.params.map(v => { // 把参数转成字符串，后台有的接口会强校验数值类型
        return v + ''
      })
      return res
    }
  },
  watch: {
    showToday() {
      if (this.unit.value === 'hour' || this.unit.value === 'day') {
        this.customCount = this.showToday ? 0 : 1
        this.onRelative(this.customCount)
      }
    },
    hourAble (able) {
      if (!able && this.unit.value === 'hour') {
        this.unit = {value: 'day'}
        this.onRelative(this.isUltralimit ? 1 : 7)
      }
    },
    relativeDateIncludeToday (includeToday) {
      this.maxDate = new Date(new Date().getTime() - (includeToday ? 0 : 1) * this.$util.dayTime)
      if (this.dateType === 'relative') {
        this.customCount = parseInt(this.value.params[0])
        // 当前相对时间为"今天"但今天不可用时：设置选项为昨天
        if (this.unit.value === 'hour' && !includeToday && this.customCount === 0) {
          this.customCount = 1
          let yesterdayStr = util.dateFormat(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
          this.hourDate = new Date(...yesterdayStr.split('-'))
        }

        let absolute = this.getAbsoluteDate(this.unit.value, this.customCount, this.maxDate)
        this.dateRange.startDate = absolute.startDate
        this.dateRange.endDate = absolute.endDate
      }
      if (this.dateType === 'absolute' && !includeToday) {
        // 绝对日期包含今天，但今天不可用时：设置结束时间为昨天
        let beginDateStr = util.dateFormat(this.dateRange.startDate)
        let endDateStr = util.dateFormat(this.dateRange.endDate)
        let todayStr = util.dateFormat(new Date())
        let yesterdayStr = util.dateFormat(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
        if (Date.parse(beginDateStr) >= Date.parse(todayStr) && !this.relativeDateIncludeToday) {
          this.dateRange.startDate = new Date(...yesterdayStr.split('-'))
        }
        if (Date.parse(endDateStr) >= Date.parse(todayStr) && !this.relativeDateIncludeToday) {
          this.dateRange.endDate = new Date(...yesterdayStr.split('-'))
        }
        if (this.value.unit === 'hour' && Date.parse(beginDateStr) >= Date.parse(todayStr) && !this.relativeDateIncludeToday) {
          this.hourDate = new Date(...yesterdayStr.split('-'))
        }
      }
      this.submit()
    }
  },
  mounted () {
    this.submit()
  },
  methods: {
    onChangeUnit () {
      // 重置默认选择：按小时默认昨天；按天默认最近七天；按周默认最近4周；按月默认最近一个月
      switch (this.unit.value) {
        case 'hour':
          this.customCount = 1
          break
        case 'day':
          this.customCount = this.isUltralimit ? 1 : 7
          break
        case 'week':
          this.customCount = 4
          break
        case 'month':
          this.customCount = 1
          break
      }
      this.onRelative(this.customCount)
    },
    getAbsoluteDate (unit, count, maxDate) {
      let res = {
        startDate: null,
        endDate: null
      }
      switch (unit) {
        case 'hour':
          res.endDate = res.startDate = new Date(new Date().getTime() - count * this.$util.dayTime)
          break
        case 'day':
          res.startDate = new Date(new Date().getTime() - count * this.$util.dayTime)
          res.endDate = maxDate
          break
        case 'week':
          res.endDate = maxDate
          // 减一是因为这里以周一为一周的第一天，如果以周日为第一天，则去掉就行
          let firstOfWeek = new Date(maxDate.getTime() - (maxDate.getDay() - 1) * this.$util.dayTime)
          res.startDate = new Date(firstOfWeek.getTime() - count * 7 * this.$util.dayTime)
          break
        case 'month':
          res.endDate = maxDate
          // 这里-1是为了将日期置为一号
          let firstOfMonth = new Date(maxDate.getTime() - (maxDate.getDate() - 1) * this.$util.dayTime)
          firstOfMonth.setMonth(firstOfMonth.getMonth() - count)
          res.startDate = new Date(firstOfMonth)
          break
      }
      return res
    },
    onRelative (count) {
      this.customCount = parseInt(count)
      this.dateType = 'relative'
      // 同步绝对时间信息
      let absolute = this.getAbsoluteDate(this.unit.value, this.customCount, this.maxDate)
      switch (this.unit.value) {
        case 'hour':
          this.hourDate = absolute.startDate
          break
        case 'day':
        case 'week':
        case 'month':
          this.dateRange.startDate = absolute.startDate
          this.dateRange.endDate = absolute.endDate
          break
      }
      this.submit()
    },
    onAbsolute () {
      this.dateType = 'absolute'
      this.submit()
    },
    onClickOutside () {
      this.expand = false
      // 对数据进行还原
      if (this.value) {
        this.dateType = this.value.dateType
        this.unit.value = this.value.unit
        if (this.dateType === 'relative') {
          this.customCount = parseInt(this.value.params[0])
          let absolute = this.getAbsoluteDate(this.unit.value, this.customCount, this.maxDate)
          this.dateRange.startDate = absolute.startDate
          this.dateRange.endDate = absolute.endDate
        } else {
          if (this.$util.isDate(this.value.params[0])) {
            this.dateRange.startDate = this.value.params[0]
            this.dateRange.endDate = this.value.params[1]
            if (this.value.unit === 'hour') {
              this.hourDate = new Date(...this.value.params[0].split('-'))
            }
          } else if (this.$util.isString(this.value.params[0])) { // yyyy-mm-dd
            this.dateRange.startDate = new Date(this.value.params[0])
            this.dateRange.endDate = new Date(this.value.params[1])
            if (this.value.unit === 'hour') {
              this.hourDate = new Date(this.value.params[0])
            }
          }
        }
      }
    },
    submit () {
      this.expand = false
      this.$emit('input', this.output)
      this.$emit('change')
    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
